import React, { useEffect, useState } from "react";

import { Row, Col } from "react-bootstrap";

import { useRouter } from "../../../../../util/router";
import GYAxios from "../../../../../util/GYAxios";

import FormBody from "./FormBody";
import { useClientUsersFormContext } from "../../../../../util/clientUsersFormContext";

const UsersForm = (props) => {
	const router = useRouter();

	const [selectedClient, setSelectedClient] = useState(false);
	const [existingUsers, setExistingUsers] = useState([]);
	const [reload, setReload] = useState(true);
	const [formMode, setFormMode] = useState("");
	const [users, setUsers] = useState(false);

	const { selectedClientUsers, selectedClientUserIds } = useClientUsersFormContext();

	const backBtnStyle = {
		cursor: "pointer",
		padding: "0px 5px",
		float: "right",
		fontSize: "2rem",
	};

	/**
	 * Fetch selected client's info
	 * @param {string} clientID
	 */
	const fetchClientInfo = (clientID) => {
		const clientURI = `/client/${clientID}`;

		GYAxios.get(clientURI).then((res) => {
			const client = !res.data.error ? res.data[0] : false;
			setSelectedClient(client);
			setReload(false);
		});
	};

	/**
	 * Fetch users of selected client and site
	 * @param {string} clientID
	 * @param {string} siteID
	 * @param {string} currentFormMode
	 */
	const fetchClientUsers = (clientID, siteID, currentFormMode) => {
		const siteIsSelected = siteID != "ALL";

		const usersURI = !siteIsSelected
			? `/users/filter?column=client_id&value=${clientID}`
			: `/users/singlesite/filter?client=${clientID}&site=${siteID}`;

		GYAxios.get(usersURI).then((res) => {
			const users = !res.data.error ? res.data : [];
			const formattedUsers = users.map((user) => formatUsers(user));

			// Only users that are not exported to KC are editable
			// Filter out users that are already exported
			// const filteredUsers = formattedUsers.filter(
			// 	(user) => user.exported_status == 0
			// );

			setExistingUsers(formattedUsers);

			if(currentFormMode === "EDIT") {
				const usersToEdit = selectedClientUsers?.map(user => formattedUsers.find(_user => parseInt(user.user_id) === parseInt(_user.user_id))) || selectedClientUserIds?.map(id => formattedUsers.find(user => user.user_id === id)).filter(user => !!user);
				// if there is no users to edit, return to client users page
				if(!usersToEdit?.length) {
					return router.push("/solar/administration/users/clients");
				}
				setUsers(usersToEdit);
			}
			if(currentFormMode === "NEW") {
				setUsers([]);
			}

			setReload(false);
		});
	};

	/**
	 * Format user object
	 * @param {obj} user
	 * @returns user object
	 */
	const formatUsers = (user) => {
		const seesAllSites = user.site_id === "all";
		const seesInvoices = user.see_invoice == 1;
		const seesReports = user.see_report == 1;
		const receivingEInvoice = user.receiving_einvoice == 1;

		const addtlProps = {
			seesAllSites,
			seesInvoices,
			seesReports,
			receivingEInvoice
		};

		return { ...user, ...addtlProps };
	};

	useEffect(() => {
		const pathname = router.pathname;
		const pathSplit = pathname.split("/");

		const siteIsSelected = pathSplit.length == 11;

		if (reload) {
			const clientID = pathSplit[8];
			const siteID = siteIsSelected ? pathSplit[10] : "ALL";

			const currentFormMode = pathSplit[6].toUpperCase();

			if (!selectedClient || props.selectedClient !== selectedClient.id) {
				fetchClientInfo(clientID);
				fetchClientUsers(clientID, siteID, currentFormMode);
			}

			setFormMode(currentFormMode);
		}
	}, [router.pathname, reload]);

	return (
		<div className="perf-table panel panel-default">
			<div className="panel-heading ">
				<Row>
					<Col md="10">
						<h2 className="panel-title">
							Client Users - {selectedClient && selectedClient.company}
						</h2>
					</Col>
					<Col md="2">
						<span
							className="glyphicon glyphicon-chevron-left"
							style={backBtnStyle}
							onClick={() => router.push(`/solar/administration/users/clients`)}
						></span>
					</Col>
				</Row>
			</div>
			{users && (
				<FormBody
					users={users}
					formMode={formMode}
					client={selectedClient}
					existingUsers={existingUsers}
					setReload={setReload}
				/>
			)}
		</div>
	);
};

export default UsersForm;
